import { Form } from "antd";
import { useEffect, useState } from "react";
import { apiClient } from "../../api/apiClient";
import { getApiErrorMessage } from "../utils/apiError";

export function useSave(endpoint: string, onSaved: (entity: unknown) => void, onCancel: () => void, mode: "create" | "edit" = "create", id?: string | number | null) {
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const save = async (values: Record<string, unknown>) => {
    setSaving(true);
    setError(null);
    try {
      const target = mode === "edit" && id && !endpoint.includes(String(id))
        ? `${endpoint}/${id}`
        : endpoint;
      const { data } = mode === "edit" && id
        ? await apiClient.put(target, values)
        : await apiClient.post(endpoint, values);
      onSaved(data?.data ?? data ?? values);
    } catch (err) {
      setError(getApiErrorMessage(err, "Unable to save"));
    } finally {
      setSaving(false);
    }
  };
  return { saving, error, save, onCancel };
}

export function useEditData(form: ReturnType<typeof Form.useForm>[0], endpoint: string, mode: "create" | "edit", id?: string | number | null) {
  useEffect(() => {
    if (mode !== "edit" || !id) return;
    let active = true;
    apiClient.get(`${endpoint}/${id}`).then(({ data }) => {
      if (active) form.setFieldsValue(data?.data ?? data);
    }).catch(() => undefined);
    return () => { active = false; };
  }, [endpoint, form, id, mode]);
}
